export default {
    delete_keyfob_title: "Delete DriverID Tag",
    delete_keyfob_success_message: "The driverID tag has been deleted",
    delete_keyfob_label: "Are you sure you want to delete the driverID ta?",
    delete_keyfob_warning: "This action cannot be undone. This will permanently delete the data and its associations.",
}